var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container d-flex flex-column align-items-center" },
    [
      _c("h2", { staticClass: "text-white w-100 text-center" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.confirmed
                ? _vm.$t("message.accountActivated")
                : _vm.$t("message.accountActivationFailed")
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.confirmed
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-between w-100 flex-wrap",
              staticStyle: { "white-space": "pre-wrap" },
            },
            [
              _vm.features.vkAuth
                ? _c(
                    "h4",
                    { staticClass: "text-white mt-5 w-100 text-center col-12" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$tc("message.linkSocials", +_vm.features.vkAuth, {
                            socials: _vm.socials,
                          })
                        ) + " "
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "settings-button",
                          attrs: { to: "/account" },
                        },
                        [_vm._v(_vm._s(_vm.$t("button.accountSettings")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "h4",
                { staticClass: "text-white my-5 w-100 text-center col-12" },
                [_vm._v(_vm._s(_vm.$t("message.visitOtherApp")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex col-6 justify-content-center" },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/websitesIcons/mirera_icon.png"),
                      width: "36px",
                      height: "36px",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "ml-2",
                      staticStyle: { "font-size": "1.5rem", color: "white" },
                      attrs: { href: _vm.mireraPath },
                    },
                    [_vm._v(_vm._s(_vm.mireraName))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex col-6 justify-content-center" },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/websitesIcons/piktomir_icon.png"),
                      width: "36px",
                      height: "36px",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "ml-2",
                      staticStyle: { "font-size": "1.5rem", color: "white" },
                      attrs: { href: _vm.piktomirPath },
                    },
                    [_vm._v(_vm._s(_vm.piktomirName))]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }